// import { data } from "isotope-layout";
import PropTypes from "prop-types";
import React from 'react';
// import {Link} from "react-router-dom";
// import FileName from '../../data/pic/filename.json';



const WorkDetailsContainer = () => {
    // const cate = data.categories.map((value, i) => {
    //     return(
    //         <span className="d-inline" key={i}>{value}{i !== data.categories.length - 1 && " , "}</span>
    //     )
    // })
    return (
        <div className="section section-padding">
            <div className="container">
                <div className="row pt--100 pb--80">

                    <div className="col-lg-4 col-md-6 col-12">
                        <div className="work-left work-details" data-aos="fade-up">
                            <div className="portfolio-main-info">
                                <h2 className="title">Wonderful Moments </h2>
                                <div className="work-details-list mt-12">

                                    <div className="details-list">
                                        <label>Years</label>
                                        <span>2025</span>
                                    </div>
                                    <div className="details-list">
                                        <label>Date</label>
                                        <span>19th-22th, Dec</span>
                                    </div>

                                    <div className="details-list">
                                        <label>Location</label>
                                        <span> Beijing, China</span>
                                    </div>


                                    {/* <div className="details-list">
                                        <label>Awards</label>
                                        <span>{data.awards}</span>
                                    </div> */}

                                </div>
                                {/* <div className="work-share pt--70 pt_md--40 pt_sm--40">
                                    <h6 className="heading heading-h6">SHARE</h6>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-7 col-md-6 offset-lg-1 col-12">
                        <div className="work-left work-details mt-6">
                            <div className="work-main-info">
                                <div className="work-content">
                                    <h4 className="title" data-aos="fade-up">The Tenth International Conference on Data Mining and Big Data (DMBD&apos;2025)</h4>

                                    <div className="desc mt-8">
                                        <p>
                                        The 10th International Conference on Data Mining and Big Data (DMBD2025) was successfully held from December 19 to 22, 2025, at Peking University in Beijing, China.                                        
                                        </p>

                                        <p>
                                        This conference offered a high-level academic platform for scholars and industry experts from around the world to present and explore the latest scientific achievements, innovative concepts, and cutting-edge technologies and applications in data mining, big data, and their related fields. The rich program covered a wide range of core topics, fostering intellectual exchange and collaboration.
                                        </p>
                                    


                                    


                                        {/* {data.body.map((value, i) => {
                                            return(
                                                <div key={i} className="content mb-5" data-aos="fade-up" dangerouslySetInnerHTML={{__html: value}} />
                                            )
                                        })} */}
{/* DONE: fix the linkage problem  */}
                                        {/* <div className="work-btn" data-aos="fade-up">
                                            <a className="btn btn-primary btn-hover-secondary" href="www.baidu.com">Baidu</a>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
    <div className="col-lg-12 col-md-6 col-12">
        <div className="thumbnail" data-aos="fade-up">
        <a href="./images/gallery/001-opt.jpg">

            <img className="w-100" src="./images/gallery/001-opt.jpg" alt="Agency" /></a>
        </div>
    </div>


</div>

                {/* <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Tutorial</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>The tutorial started at 8:00 am on Dec 10. The chairman of DMBD&apos;2023, Prof. Bi Ying give the speech Evolutionary Deep Learning for Image Classification: A Genetic Programming Approach </p>
                            </div>
                        </div>
                    </div>
                </div> */}

{/* 
                <div className="custom-layout-gallery mt-lg-20 mt-12">

                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/IMG_2539.JPG">

                                <img className="w-100" src="./images/gallery/IMG_2539.JPG" alt="Agency" /></a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/IMG_2707.JPG">

                                <img className="w-100" src="./images/gallery/IMG_2707.JPG" alt="Agency" /></a>
                            </div>
                        </div>


                    </div>
                </div> */}


                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Opening Ceremony</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>The conference officially started at 9:00 am on Dec 20. The chairman of DMBD&apos;2025, Prof. Tan Ying presided over the opening ceremony of the conference and gave an opening speech. Prof. Tan Ying reported on the meeting and extended a warm welcome to everyone. </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="custom-layout-gallery mt-lg-20 mt-12">

{/* <div className="row">
    <div className="col-lg-6 col-md-6 col-12">
        <div className="thumbnail" data-aos="fade-up">
        <a href="./images/gallery/2.JPG">

            <img className="w-100" src="./images/gallery/2.JPG" alt="Agency" /></a>
        </div>
    </div>
    <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
        <div className="thumbnail" data-aos="fade-up">
        <a href="./images/gallery/3-opt.jpg">

            <img className="w-100" src="./images/gallery/3-opt.jpg" alt="Agency" /></a>
        </div>
    </div>


</div> */}
            <div className="col-lg-12 col-md-6 col-12">
                <div className="thumbnail" data-aos="fade-up">
                <a href="./images/gallery/2.JPG">

                    <img className="w-100" src="./images/gallery/2.JPG" alt="Agency" /></a>
                </div>
            </div>
        </div>


                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Plenary Speech</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>First, DMBD&apos;2025 was honored to invite Prof.Ying Tan to give a plenary speech at the conference. </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="custom-layout-gallery mt-lg-20 mt-12">
 
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/3-opt.jpg">

                                <img className="w-100" src="./images/gallery/3-opt.jpg" alt="Agency" /></a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/4-opt.jpg">

                                <img className="w-100" src="./images/gallery/4-opt.jpg" alt="Agency" /></a>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">The conference was energized by a keynote from Ying Tan of Peking University, who presented on <strong>&quot;Big Data: Technology-Driven Innovation and the Future of Industry.&quot;</strong> The talk masterfully traced the evolution of big data from a technical concept to a core strategic asset, detailing its critical role in research, industrial upgrade, and financial decision-making. The audience gained a clear, end-to-end understanding of the data value chain, from collection to analysis, with deep dives into foundational technologies like Hadoop and HDFS. The session culminated in a compelling case study on financial big data platforms, vividly demonstrating how the synergy of big data and AI is not just improving but revolutionizing the entire financial industry.</p>
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/IMG_3451.JPG">

                                <img className="w-100" src="./images/gallery/IMG_3451.JPG" alt="Agency" /></a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/IMG_3649.JPG">

                                <img className="w-100" src="./images/gallery/IMG_3649.JPG" alt="Agency" /></a>
                            </div>
                        </div>


                    </div> */}
                </div>

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Invited Talks</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>Second, DMBD&apos;2025 was honored to invite three scholars to deliver invited talks at the conference. </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="custom-layout-gallery mt-lg-20 mt-12">
 
                    <div className="row">
                        <div className="col-lg-2 col-md-2 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/3-opt.jpg">

                                <img className="w-100" src="./images/avatar/Karthik.jpg" alt="Agency" /></a>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">A conference highlight was the highly practical session delivered by Karthik Nallani Chakravartula, a Senior Software Engineer from Farm Credit Bank, USA. His talk, <strong>&quot;From CRM Data to Decisions: Practical Analytics on Dynamics 365 plus Microsoft Fabric,&quot;</strong> cut through the theoretical to deliver a powerful, actionable blueprint for transforming raw CRM data into trustworthy business intelligence. Attendees were given a clear, end-to-end reference architecture for building a modern analytics pipeline—from streaming incremental changes into OneLake and structuring data in a medallion layout to implementing row-level security and ensuring audit compliance. Grounded in a real-world agri-banking scenario, this session provided the crucial &quot;how-to&quot; that teams need to move beyond static dashboards and start driving real, data-informed decisions in a matter of weeks.</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-2 col-md-2 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/3-opt.jpg">

                                <img className="w-100" src="./images/avatar/Aravind.jpeg" alt="Agency" /></a>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">The conference addressed a paramount concern with a pivotal talk by Aravind Raghu, a Lead Full Stack Engineer from HYR Global Source. His session, <strong>&quot;Zero-Trust Security in the Age of Generative AI,&quot;</strong> provided an essential and timely framework for hardening AI systems against a new frontier of threats. Moving beyond traditional security models, Raghu detailed a practical zero-trust architecture designed specifically for AI—applying the principles of &quot;never trust, always verify&quot; and &quot;least privilege&quot; across the entire pipeline, from data ingestion and model inference to AI agent actions. Grounded in examples from fintech and regulated industries, the talk equipped attendees with a clear mental model of AI vulnerabilities and a actionable checklist of controls, empowering them to build innovative yet secure and reliable generative AI applications.</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-2 col-md-2 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/3-opt.jpg">

                                <img className="w-100" src="./images/avatar/ahmet-opt.jpg" alt="Agency" /></a>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">The morning&apos;s keynote sessions culminated in a powerful and comprehensive overview delivered by Ahmet Tuğrul Bayrak, Data Science and Innovation Manager at Ata Technology Platforms, Turkey. His talk, <strong>&apos;Advances in Generative AI: Benefits, Challenges, and Ethical Considerations,&apos;</strong> masterfully balanced the immense potential of the technology with its profound societal responsibilities. Bayrak guided the audience through the foundational breakthroughs—from word embeddings to GPT—that have revolutionized industries, while simultaneously addressing the critical dualities of innovation: the tension between productivity gains and the risks of bias, misinformation, and misuse. This session stood out for its urgent call to action, leaving attendees not only with a deep appreciation for AI&apos;s technical evolution but also with a clear mandate: to champion responsible innovation through strong ethical guidelines, transparent governance, and robust regulatory measures to ensure these powerful technologies truly serve the greater good.</p>
                        </div>
                    </div>
                </div>



                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Tutorial</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>Third, DMBD&apos;2025 was honored to invite Prof.Lili Jiang to give a tutorial at the conference. </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="custom-layout-gallery mt-lg-20 mt-12">
 
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/5-opt.jpg">

                                <img className="w-100" src="./images/gallery/5-opt.jpg" alt="Agency" /></a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/6-opt.jpg">

                                <img className="w-100" src="./images/gallery/6-opt.jpg" alt="Agency" /></a>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">The conference was honored to host Prof. Lili Jiang from Umeå University, who delivered an insightful invited tutorial on <strong>&quot;Trustworthiness in Data Science: Fairness, Privacy and Explainability.&quot;</strong> As an expert in the field, Prof. Jiang provided a comprehensive roadmap for building responsible AI systems, breaking down the complex pillars of trustworthiness into actionable concepts. Attendees gained valuable insights into auditing for bias, implementing privacy protections like differential privacy, and creating explainable models, all grounded in real-world case studies from the EU COMFORT project. The session sparked a highly engaged and thought-provoking discussion on the ethical imperatives and practical challenges of deploying AI in high-stakes domains like healthcare, perfectly aligning with the conference&apos;s focus on cutting-edge and responsible data science.</p>
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/IMG_3451.JPG">

                                <img className="w-100" src="./images/gallery/IMG_3451.JPG" alt="Agency" /></a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/IMG_3649.JPG">

                                <img className="w-100" src="./images/gallery/IMG_3649.JPG" alt="Agency" /></a>
                            </div>
                        </div>


                    </div> */}
                </div>





                {/* ---------------------------invited best student paper presentation */}

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Awards</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>We have invited the authors of the Best Paper and the Best Student Paper to give presentations and receive their awards.
</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/7-opt.jpg">

                                <img className="w-100" src="./images/gallery/7-opt.jpg" alt="Agency" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/8-opt.jpg">

                                <img className="w-100" src="./images/gallery/8-opt.jpg" alt="Agency" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">The author of <strong>&quot;A Chinese Text Deduplication Method Integrating Semantics&quot;</strong> presented the conference&apos;s Best Paper. The presentation detailed a novel method that overcomes the limitations of traditional lexical analysis by integrating semantic understanding at the sentence level. Attendees engaged in a vibrant discussion on the future of NLP and data quality, particularly praising the method&apos;s impressive 96.72% precision and its potential applications across various text-processing domains.</p>
                        </div>
                    </div>
                    <hr />
                    <div className="row mt-lg-20 mt-12">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/9-opt.jpg">
                                <img className="w-100" src="./images/gallery/9-opt.jpg" alt="Agency" />

                            </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/10-opt.jpg">

                                <img className="w-100" src="./images/gallery/10-opt.jpg" alt="Agency" />
                            </a>
                            </div>

                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">We celebrated the next generation of researchers as the winner of the Best Student Paper Award presented <strong>&quot;A Bayesian Network Model for Assessing Sales Risk in E-commerce Live-Streaming: A Retailer&apos;s Perspective.&quot;</strong> The talk expertly broke down a complex, data-driven Bayesian network model designed to quantify risk for retailers in the fast-growing live-streaming e-commerce sector. The audience participated in an insightful Q&A, exploring the practical implications of the model&apos;s risk predictions and its use of Dempster-Shafer theory to integrate expert knowledge.</p>
                        </div>
                    </div>
                </div>

                                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Invited Presentations</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>The invited authors sequentially presented their latest results.
</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/11-opt.jpg">

                                <img className="w-100" src="./images/gallery/11-opt.jpg" alt="Agency" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/12-opt.jpg">

                                <img className="w-100" src="./images/gallery/12-opt.jpg" alt="Agency" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-lg-6 col-md-6 col-12">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">The session continued with a presentation on <strong>&quot;An Adaptive Ensemble Learning Strategy Dynamic Selection Method.&quot;</strong> The author introduced a sophisticated dynamic ensemble framework that adaptively combines Boosting, Bagging, and Stacking strategies to significantly improve credit risk assessment models. Participants were keen to discuss the meta-learning and fuzzy integral components, debating how this adaptive approach could be generalized for other dynamic financial environments.</p>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-3">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">The author of <strong>&quot;Fuzzy Spatial High Utility Co-location Patterns Mining Based on Extended Regions&quot;</strong> introduced an innovative data mining approach. The talk focused on moving beyond fixed distance thresholds by using fuzzy logic and clustering to reveal more meaningful spatial patterns. The audience actively explored the real-world geographic information system (GIS) applications where discovering these &quot;hidden correlations&quot; would be most impactful.

</p>
                        </div>
                    </div>
                    <hr />
                    <div className="row mt-lg-20 mt-12">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/13-opt.jpg">

                                <img className="w-100" src="./images/gallery/13-opt.jpg" alt="Agency" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/14-opt.jpg">

                                <img className="w-100" src="./images/gallery/14-opt.jpg" alt="Agency" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-lg-6 col-md-6 col-12">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">A deep dive into data integrity and reliability was provided by the author of <strong>&quot;A Class of Locally Repairable Codes for Cloud Storage.&quot;</strong> The presentation outlined an algebraic construction for codes that efficiently repair failed storage nodes while simultaneously verifying data integrity against tampering. This sparked a technical discussion among attendees on the balance between storage cost, repair efficiency, and security in modern distributed systems.</p>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-3">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">The author of <strong>&quot;Edge-Optimized Multimodal Learning for UAV Video Understanding via BLIP-2&quot;</strong> demonstrated a compelling solution to the challenge of running large vision-language models on resource-constrained drone hardware. By integrating BLIP-2 with YOLO models and a smart key-frame sampling mechanism, the platform enables real-time aerial video understanding. The audience was particularly interested in the zero-shot performance and the practical deployment possibilities for UAVs.</p>
                        </div>
                    </div>
                    <hr />
                    <div className="row mt-lg-20 mt-12">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/15-opt.jpg">

                                <img className="w-100" src="./images/gallery/15-opt.jpg" alt="Agency" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/16-opt.jpg">

                                <img className="w-100" src="./images/gallery/16-opt.jpg" alt="Agency" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-lg-6 col-md-6 col-12">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">The presentation on <strong>&quot;A Study on Explainable Graph Anomaly Detection via Graph Contrastive Learning&quot;</strong> addressed the critical need for explainability in AI. The author presented a novel framework using a dual-propagation graph encoder and multi-scale contrastive learning to not only detect anomalies in networks but also explain why a node is considered anomalous. This led to a rich conversation about trust and interpretability in complex graph-based machine learning models.</p>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-3">
                            <p className="mb-0 gallery-image-caption" data-aos="fade-up">The final best moment featured the author of <strong>&quot;Resu: A regularized and non-monotonic activation function for convolution neural network,&quot;</strong> who explored the fundamental building blocks of deep learning. The talk proposed a new activation function designed to provide appropriate sparsity, arguing its crucial role in reducing training loss and improving network performance. This foundational research prompted a lively exchange on the ongoing evolution of activation functions and their direct impact on model capability.</p>
                        </div>
                    </div>
                </div>

{/* -------------------------------------------------------------- */}
{/* parellel sessions */}
{/* -------------------------------------------------------------- */}
                {/* <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Parallel Sessions</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>All the authors of DMBD&apos;2024 presented their papers at the conference. There are four parallel sessions meeting rooms in total. Participants can choose topics and papers of interest, listen to their reports and communicate with the authors. </p>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* gallery */}
                {/* <div className="custom-layout-gallery mt-lg-20 mt-12">

                    <div className="row">

                        {FileName.map((data, i) => {
                            return(
                                <div className="col-lg-4 col-md-4 col-12" key={i}>
                                                <div className="thumbnail" data-aos="fade-up">
                                                    <a href={"./images/gallery/" +data.file}>
                                                    <img className="w-100" src={"./images/gallery/" +data.file} alt={data.file} />
                                                    </a>
                                                </div>
                                            </div>
                                            )
                                        })}


                    </div>
                </div> */}
{/* -------------------------------------------------------------- */}
{/* award ceremony */}
{/* -------------------------------------------------------------- */}
                            {/* <div className="row mt-lg-20 mt-12">
                                <div className="col-lg-4 col-md-12 col-12">
                                    <div className="digital-marketing" data-aos="fade-up">
                                        <h3 className="heading heading-h3">Award Ceremony
</h3>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                                    <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                                        <div className="inner">
                                            <p>On the evening of Dec 10, the conference held an award ceremony. Prof. Ying Tan announced all the awards of this year&apos;s conference and took a group photo with them. </p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* gallery */}
                            {/* <div className="custom-layout-gallery mt-lg-20 mt-12"> */}
                                    {/* big one */}
                                    {/* <div className="col-lg-12 my-6">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/plenary talk 1.JPG" alt="Agency" />
                                        </div>
                                    </div> */}
                                {/* <div className="row">
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/IMG_4635.JPG" alt="Agency" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/IMG_4648.JPG" alt="Agency" />
                                        </div>
                                    </div>
            
            
                                </div> */}

            


                            {/* </div> */}
            {/* -------------------------------------------------------------- */}


            </div>
        </div>
    )
}

WorkDetailsContainer.propTypes = {
    data: PropTypes.object
};

export default WorkDetailsContainer;
